import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

const BrowserLarge = ({ className, domain, subDomain }) => {
  return (
    <svg className={className} viewBox="0 0 449 310">
      <defs>
        <path
          d="M0 3.996C0 1.789 1.789 0 4.0083 0h435.9834C442.2054 0 444 1.7911 444 3.996v297.008c0 2.207-1.789 3.996-4.0083 3.996H4.0083C1.7946 305 0 303.2088 0 301.004V3.996z"
          id="browser-large-b"
        />
        <filter
          x="-.6%"
          y="-.8%"
          width="101.8%"
          height="102.6%"
          filterUnits="objectBoundingBox"
          id="browser-large-c"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dx="3"
            dy="3"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1146 0"
            in="shadowOffsetOuter1"
          />
        </filter>
      </defs>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <mask id="browser-large-d" fill="#fff">
          <use xlinkHref="#browser-large-b" />
        </mask>
        <use
          fill="#000"
          filter="url(#browser-large-c)"
          xlinkHref="#browser-large-b"
        />
        <use fill="#E8EBED" xlinkHref="#browser-large-b" />
        <path
          strokeOpacity=".0751"
          stroke="#000"
          d="M-.5 3.996C-.5 1.5107 1.515-.5 4.0083-.5h435.9834c2.4888 0 4.5083 2.014 4.5083 4.496v297.008c0 2.4853-2.015 4.496-4.5083 4.496H4.0083C1.5195 305.5-.5 303.486-.5 301.004V3.996z"
        />
        <rect
          fill="#FFF"
          mask="url(#browser-large-d)"
          x="48"
          y="4"
          width="287"
          height="18"
          rx="3"
        />
        <text
          mask="url(#browser-large-d)"
          fontFamily="FaktPro-Normal, Fakt Pro"
          fontSize="9"
        >
          <tspan x="55" y="16" fill="#919599">
            http://
          </tspan>
          <tspan y="16" fill="#17181A">
            {subDomain}
          </tspan>
          <tspan y="16" fill="#6A6D70">
            .{domain}
          </tspan>
        </text>
        <circle
          fill="#CECECE"
          mask="url(#browser-large-d)"
          cx="11.5"
          cy="14.5"
          r="3.5"
        />
        <circle
          fill="#CECECE"
          mask="url(#browser-large-d)"
          cx="21.5"
          cy="14.5"
          r="3.5"
        />
        <circle
          fill="#CECECE"
          mask="url(#browser-large-d)"
          cx="31.5"
          cy="14.5"
          r="3.5"
        />
      </g>
    </svg>
  );
};

BrowserLarge.propTypes = {
  className: PropTypes.string,
  domain: PropTypes.string.isRequired,
  subDomain: PropTypes.string,
};

BrowserLarge.defaultProps = {
  subDomain: I18n.t('form.onboarding.placeholder.subdomain_name'),
};

export default BrowserLarge;
